import auth from './auth'
import permissions from './permissions'

export default router => {
  router.beforeEach(auth)
  router.beforeEach(permissions)
}
